import { createSlice } from "@reduxjs/toolkit";

const financeSlice = createSlice({
  name: "Finance",
  initialState: {
    banksList: {},
  },
  reducers: {
    setBankListing(state, action) {
      state.banksList = { ...action.payload };
    },
  },
});

export const financeSliceActions = financeSlice.actions;

export default financeSlice.reducer;
